import { z } from "zod";

import {
  ListNotificationsQuerySchema,
  ListNotificationsResponseSchema,
  NotificationInboxItemSchema,
  NotificationSummarySchema,
} from "@recobra/schemas/notification";
import type { CreateBroadcastNotificationInput } from "@recobra/schemas/notification";
import { NotificationRecordSchema } from "@recobra/schemas/notification";

import { requestJson } from "./client";

type ListNotificationsQuery = z.infer<typeof ListNotificationsQuerySchema>;

const listSearchParams = (params: Partial<ListNotificationsQuery>): string => {
  const search = new URLSearchParams();
  if (params.filter) search.set("filter", params.filter);

  return search.toString();
};

const countResponseSchema = z.object({ count: z.number().int() });

export const notificationsApi = {
  list: (params?: Partial<ListNotificationsQuery>) => {
    const qs = listSearchParams(params ?? {});

    return requestJson(
      qs ? `/notifications?${qs}` : "/notifications",
      ListNotificationsResponseSchema,
    );
  },

  summary: () => requestJson("/notifications/summary", NotificationSummarySchema),

  markRead: (id: string) =>
    requestJson(`/notifications/${id}/read`, NotificationInboxItemSchema, { method: "PATCH" }),

  markAllRead: () =>
    requestJson("/notifications/mark-all-read", countResponseSchema, { method: "POST" }),

  clearRead: () =>
    requestJson("/notifications/clear-read", countResponseSchema, { method: "DELETE" }),

  broadcast: (body: CreateBroadcastNotificationInput) =>
    requestJson("/notifications/broadcast", NotificationRecordSchema, {
      method: "POST",
      body: JSON.stringify(body),
    }),
};
